export default {
  apiBaseUrl: 'https://staging-api.qhlth.com/api/',
  socketUrl: 'https://staging-api.qhlth.com/',
  webUrl: 'https://staging-app.qhlth.com/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: true,
  nutritionixAppId: '94e4784e',
  nutritionixAppKey: '06b5b7dd2280bfd224041a02ac9b740f',
  withingsClientId:
    'ce6f499a15768464925837c758d215f906cc1f25ea9e44c5f81ee3d680ab8992',
  withingsRedirectUrl: 'https://staging-api.qhlth.com/api/withings/callback',
  fitbitAppClientId: '23QQXZ',
  fitbitRedirectWebUri: 'https://localhost:19006/*',
  fitbitRedirectAppUri: 'com.qhlth.staging2://home',
  privacyPolicyUrl: 'https://quratehealth.com/privacy',
  loginAgreements: {
    privacyPolicy: 'https://quratehealth.com/privacy'
  },
  debug: true,
  iosAppLink: 'https://appdistribution.firebase.dev/i/bea975c84a18a4a7',
  androidAppLink: 'https://appdistribution.firebase.dev/i/cc868ad768dd6bf6',
  videoCallProvider: 'zoom',
  zoomAppGroupId: 'com.qhlth.staging2',
};
